export const createPoller = (
  callback: () => Promise<void>,
  intervalMs: number,
  maxDurationMs: number,
  onComplete: () => void,
) => {
  let refetchInterval: ReturnType<typeof setInterval> | null = null;
  let expiryTimeout: ReturnType<typeof setTimeout> | null = null;

  const clearTimers = () => {
    if (refetchInterval) {
      clearInterval(refetchInterval);
      refetchInterval = null;
    }

    if (expiryTimeout) {
      clearTimeout(expiryTimeout);
      expiryTimeout = null;
    }
  };

  const stop = () => {
    clearTimers();
    onComplete();
  };

  const start = () => {
    clearTimers();

    refetchInterval = setInterval(async () => {
      try {
        await callback();
      } catch (error) {
        stop();
        console.error('Polling error:', error);
      }
    }, intervalMs);

    expiryTimeout = setTimeout(stop, maxDurationMs);
  };

  return { start: start, stop: stop };
};
